/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Selfhost_SubjectInputs */

const en_mk_selfhost_subject = /** @type {(inputs: Mk_Selfhost_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosting KerjaBareng`)
};

const id_mk_selfhost_subject = /** @type {(inputs: Mk_Selfhost_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-host KerjaBareng`)
};

/**
* | output |
* | --- |
* | "Self-hosting KerjaBareng" |
*
* @param {Mk_Selfhost_SubjectInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_selfhost_subject = /** @type {((inputs?: Mk_Selfhost_SubjectInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Selfhost_SubjectInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_selfhost_subject(inputs)
	return en_mk_selfhost_subject(inputs)
});